module.exports = __webpack_public_path__ + "static/media/email-sent.0db962d0.png";